exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-text-field__details{\n    display: block !important;\n}\n.text-green {\n    color: green;\n}\n", ""]);
